<div style='width:300px;margin:2px' *ngIf='skins.skinsSummary'>
    <h3>Skins Winner Summary</h3>
    <div fxLayout='row' class='summary-header'>
        <span fxFlex='50%' style='padding-left:2px'>Winner</span>
        <span fxFlex class='winner-cell'>$</span>
    </div>
    <div *ngFor='let player of skins.skinsSummary.player;'>
            <span fxFlex='50%' style='padding-left:2px'>{{player.player_name}}</span>
            <span fxFlex class='winner-cell'>{{player.total_win}}</span>
    </div>
</div>
<div style='width:300px;margin:2px' *ngIf='skins.gross_skins'>
    <h3>Gross Skins (Collected: {{skins.gross_skins.collected}})</h3>
    <div fxLayout='row' class='winner-gross-header'>
        <span fxFlex='50%' style='padding-left:2px'>Player</span>
        <span fxFlex class='winner-cell'>Hole</span>
        <span fxFlex class='winner-cell'>Score</span>
        <span fxFlex class='winner-cell'>$</span>
    </div>
    <div *ngFor='let winner of skins.gross_skins.skin; let i = index'>
        <div fxLayout='row' *ngIf='winner'>
            <span fxFlex='50%'>{{winner.player}}</span>
            <span fxFlex class='winner-cell'>{{winner.hole}}</span>
            <span fxFlex class='winner-cell'>{{winner.score}}</span>
            <span fxFlex class='winner-cell'>{{winner.value}}</span>
        </div>
    </div>
</div>
<div style='width:300px;margin:2px' *ngIf='skins.net_skins'>
    <h3>Net Skins (Collected: {{skins.net_skins.collected}})</h3>
    <div fxLayout='row' class='winner-gross-header'>
        <span fxFlex='50%' style='padding-left:2px'>Player</span>
        <span fxFlex class='winner-cell'>Hole</span>
        <span fxFlex class='winner-cell'>Score</span>
        <span fxFlex class='winner-cell'>$</span>
    </div>
    <div *ngFor='let winner of skins.net_skins.skin; let i = index'>
        <div fxLayout='row' *ngIf='winner'>
            <span fxFlex='50%'>{{winner.player}}</span>
            <span fxFlex class='winner-cell'>{{winner.hole}}</span>
            <span fxFlex class='winner-cell'>{{winner.score}}</span>
            <span fxFlex class='winner-cell'>{{winner.value}}</span>
        </div>
    </div>
</div>
